module.exports = __webpack_public_path__ + "static/img/TVYTbAXWheQpRcWDaDMu.5825f033.svg";